import { fr } from './fr';
import { en } from './en';

export const locales = {
	fr,
	en,
};

export const languages = [
	{ code: 'fr', name: 'Français', flag: '🇫🇷' },
	{ code: 'en', name: 'English', flag: '🇬🇧' },
] as const;

export type Language = 'fr' | 'en';
export type TranslationKeys = typeof fr;
